var render = function render(){var _vm=this,_c=_vm._self._c;return (this.$route.path === '/agenda' && _vm.ListaAgendamentos.length > 0)?_c('div',{staticClass:"floating",on:{"click":function($event){return _vm.openAgendamentosPDF(_vm.paciente.CodigoUnidade)}}},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"helper-button"},[_c('i',{staticClass:"icon-ic_print"})])
}]

export { render, staticRenderFns }